import { render } from "./termsEn.vue?vue&type=template&id=05755d56"
import script from "./termsEn.vue?vue&type=script&lang=js"
export * from "./termsEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__